
import { isExternal } from '@/utils/validate'
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
export default defineComponent({
  props: {
    to: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const router = useRouter()
    const push = () => {
      // console.log(props.to)
      router.push(props.to).catch((err) => {
        // console.log(err)
      })
    }
    return {
      push,
      isExternal
    }
  }
})
